import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userImprintCapabilitiesSoftSkillsAdapter = createEntityAdapter({})

const initialState = userImprintCapabilitiesSoftSkillsAdapter.getInitialState()

export const userImprintCapabilitiesSoftSkillsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintCapabilitiesSoftSkills: builder.query({
            query: () => ({
                url: '/userImprintCapabilitiesSoftSkills/getUserImprintCapabilitiesSoftSkills',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintCapabilitiesSoftSkills = responseData.map(userImprintCapabilitiesSoftSkill => {
                    userImprintCapabilitiesSoftSkill.id = userImprintCapabilitiesSoftSkill._id
                    return userImprintCapabilitiesSoftSkill
                })
                return userImprintCapabilitiesSoftSkillsAdapter.setAll(initialState, loadedUserImprintCapabilitiesSoftSkills)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintCapabilitiesSoftSkill', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintCapabilitiesSoftSkill', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintCapabilitiesSoftSkill', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintCapabilitiesSoftSkill: builder.mutation({
            query: initialUserImprintCapabilitiesSoftSkill => ({
                url: '/userImprintCapabilitiesSoftSkills/createNewUserImprintCapabilitiesSoftSkill',
                method: 'POST',
                body: {...initialUserImprintCapabilitiesSoftSkill,}
            }),
            invalidatesTags: [
                { type: 'UserImprintCapabilitiesSoftSkill', id: "LIST" }
            ] 
        }),
        updateUserImprintCapabilitiesSoftSkill: builder.mutation({
            query: initialUserImprintCapabilitiesSoftSkill => ({
                url: '/userImprintCapabilitiesSoftSkills/updateUserImprintCapabilitiesSoftSkill',
                method: 'PATCH',
                body: {...initialUserImprintCapabilitiesSoftSkill,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintCapabilitiesSoftSkill', id: arg.id },
                { type: 'UserImprintCapabilitiesSoftSkill', id: 'LIST' }
            ],
        }),
        deleteUserImprintCapabilitiesSoftSkill: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintCapabilitiesSoftSkills/deleteUserImprintCapabilitiesSoftSkill',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintCapabilitiesSoftSkill', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintCapabilitiesSoftSkillsQuery,
    useCreateNewUserImprintCapabilitiesSoftSkillMutation,
    useUpdateUserImprintCapabilitiesSoftSkillMutation,
    useDeleteUserImprintCapabilitiesSoftSkillMutation,
} = userImprintCapabilitiesSoftSkillsApiSlice

// returns the query result object
export const selectUserImprintCapabilitiesSoftSkillResult = userImprintCapabilitiesSoftSkillsApiSlice.endpoints.getUserImprintCapabilitiesSoftSkills.select()

// create memoized selector
const selectUserImprintCapabilitiesSoftSkillsData = createSelector(
    selectUserImprintCapabilitiesSoftSkillResult,
    userImprintCapabilitiesSoftSkillResult => userImprintCapabilitiesSoftSkillResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintCapabilitiesSoftSkills,
    selectById: selectUserImprintCapabilitiesSoftSkillById,
    selectIds: selectUserImprintCapabilitiesSoftSkillIds,
} = userImprintCapabilitiesSoftSkillsAdapter.getSelectors(state => selectUserImprintCapabilitiesSoftSkillsData(state) ?? initialState)